module.exports = __webpack_public_path__ + "static/img/Marion-Steiner.webp";